import React from "react";
import { useParams } from "react-router-dom";
import AuditTrailsTable from "../common/AuditTrailsTable";
import { RenderAuditTrailResourceType } from "../../utils/CommonGroupingItem";
import {
  getReportsAuditTrail,
  getReportsAuditTrailDropdown,
} from "../../services/reportService";

/**
 * Reports audit trail tab wrapper around the shared audit trails table.
 * @returns {JSX.Element} Reports audit trail view.
 */
const AuditTrail = () => {
  const { id } = useParams();

  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"];

  return (
    <AuditTrailsTable
      apiFunction={getReportsAuditTrail}
      filterArrApi={getReportsAuditTrailDropdown}
      apiParams={id ? { action_id: id } : {}}
      actionId={id}
      columnsToShow={columnsToShow}
      exportFileName="Reports_AuditTrail"
      isResourceNameShown
      isShowingResourceTypeFilter
      renderResourceTypeFunction={RenderAuditTrailResourceType}
      resourceNameRedirect={() => ""}
    />
  );
};

export default AuditTrail;
